import { call, put, takeLatest } from 'redux-saga/effects';

import { InsurancePolicyUserList } from '@models/InsurancePolicyUser';
import { InsurancePolicyUserApi } from '@apis/InsurancePolicyUserApi';
import { SagaPayload } from '@utils/typescript';
import { Pagination } from '@models/Pagination';

import {
  insurancePolicyUsersFetch,
  InsurancePolicyUsersFetchPayload,
  insurancePolicyUserCreate,
  InsurancePolicyUserCreatePayload,
  insurancePolicyUserUpdate,
  InsurancePolicyUserUpdatePayload,
  stateUpdate,
  StateUpdatePayload,
} from './action';

function* handleInsurancePolicyUsersFetch({ payload }: SagaPayload<InsurancePolicyUsersFetchPayload>) {
  const state: StateUpdatePayload = { policyUsers: null, pagination: undefined };
  try {
    const [policyUsers, pagination] = (yield call(InsurancePolicyUserApi.getAll, payload)) as [InsurancePolicyUserList[], Pagination];
    state.policyUsers = policyUsers;
    state.pagination = pagination;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleInsurancePolicyUserCreate({ payload }: SagaPayload<InsurancePolicyUserCreatePayload>) {
  try {
    yield call(InsurancePolicyUserApi.create, payload);
    const usersFetchPayload: InsurancePolicyUsersFetchPayload = { insurancePolicyId: payload.insurancePolicyId, page: 1 };
    yield put(insurancePolicyUsersFetch(usersFetchPayload));
  } catch { }
}

function* handleInsurancePolicyUserUpdate({ payload }: SagaPayload<InsurancePolicyUserUpdatePayload>) {
  try {
    yield call(InsurancePolicyUserApi.update, payload);
    const usersFetchPayload: InsurancePolicyUsersFetchPayload = { insurancePolicyId: payload.insurancePolicyId, page: 1 };
    yield put(insurancePolicyUsersFetch(usersFetchPayload));
  } catch { }
}

export default function* () {
  yield takeLatest(insurancePolicyUsersFetch, handleInsurancePolicyUsersFetch);
  yield takeLatest(insurancePolicyUserCreate, handleInsurancePolicyUserCreate);
  yield takeLatest(insurancePolicyUserUpdate, handleInsurancePolicyUserUpdate);
}
